/*
 * EcoSmiles — fix "Añadir al carrito" (3-sep-2026)
 * ------------------------------------------------------------
 * Antes, los formularios de "Añadir al carrito" del PDP (eco-hero__form)
 * y de la cuadrícula de colección (eco-cg__form) eran formularios HTML
 * normales sin JavaScript, así que cada submit recargaba la página y
 * mandaba al cliente directo a /cart, en vez de dejarlo seguir comprando.
 *
 * Este script intercepta CUALQUIER formulario que apunte a /cart/add en
 * todo el sitio (delegación de eventos a nivel document), lo envía por
 * fetch, y abre el carrito lateral (drawer) sin salir de la página.
 * No requiere tocar cada plantilla — funciona para el PDP, la cuadrícula
 * de colección y cualquier otro formulario de "añadir al carrito" que se
 * agregue en el futuro, siempre que use action="/cart/add".
 *
 * Se ignoran los formularios que ya están dentro de un elemento
 * <product-form> (el componente estándar del tema), porque esos ya
 * tienen su propio manejo AJAX en product-form.js.
 */
(function () {
  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.closest('product-form')) return false; // ya manejado por product-form.js
    var action = form.getAttribute('action') || form.action || '';
    return action.indexOf('/cart/add') !== -1;
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!isCartAddForm(form)) return;

    evt.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn && (submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true')) return;

    var originalBtnHtml = submitBtn ? submitBtn.innerHTML : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
    }

    var cart = getCart();
    var formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.id; })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          // Error de Shopify (sin stock, variante inválida, etc.)
          alert(response.description || response.message || 'No se pudo agregar el producto al carrito.');
          return;
        }
        if (!cart) {
          // El tema no tiene carrito lateral disponible en esta página: fallback seguro.
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: response } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: response } }));
      })
      .catch(function (e) {
        console.error('EcoSmiles add-to-cart error', e);
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          if (originalBtnHtml !== null) submitBtn.innerHTML = originalBtnHtml;
        }
      });
  });
})();
